import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ScoreRegistrationService } from '../score-registration.service';

@Component({
  selector: 'app-score-registration',
  templateUrl: './score-registration.component.html',
  styleUrls: ['./score-registration.component.scss']
})
export class ScoreRegistrationComponent implements OnInit {
  Scoreform: any
  examMode: string = '';
  entityname: any;
  EntityName: any;
  ScoreAmount: any;
  constructor(private scoreRegistrationService: ScoreRegistrationService, private fb: FormBuilder) { }
  ngOnInit(): void {
    this.Scoreform = this.fb.group({
      mobile: [''],
      whatsappMobile: [''],
      firstName: [''],
      lastName: [''],
      ambitionStream: ['0'],
      isChaithanyaStudent: ['0'],
      grade: ['0'],
      targetExam: ['0'],
      state: ['0'],
      district: ['0'],
      city: ['0'],
      examMode: ['0'],
      onlineExamLink: [''],
      examCenterName: [''],
      examRoomNumber: ['']
    });
    this.entityName()


  }
  entityName() {
    this.scoreRegistrationService.EntityDetails().subscribe({
      next: (res: any) => {
        if (!res) {
          //this.spinner.hide();
          return;
        }
        this.entityname = res
        this.EntityName=this.entityname.entityName;
        this.ScoreAmount=this.entityname.scoreAmount
        // this.spinner.hide();
      },
      error: (err: any) => {
        // this.spinner.hide();
      }
    })
  }
  onModeChange() {
    if (this.examMode ==="") {
      console.log('Please select exam mode');
    } else {
      console.log('Selected Mode:', this.examMode);
    }
  }
}
